export const RECOMMENDED_LABEL_TEST_ID = 'ancillaries-bundle-recommended';
